import { createFileRoute } from '@tanstack/react-router'

import { RootRoute } from '@/pages/faq/route-entries/root-route'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/faq')({
  component: RootRoute,
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('FAQ'),
        },
      ],
    }
  },
})
